import {AppScene} from "./AppScene";
import {createStandardAction} from "typesafe-actions";

export const loadScene = {
    request: createStandardAction('@routing/LOAD_SCENE_REQUEST')<AppScene, string | void>(),
    resolve: createStandardAction('@routing/LOAD_SCENE_RESOLVE')<AppScene>(),
    success: createStandardAction('@routing/LOAD_SCENE_SUCCESS')<AppScene>(),
    failure: createStandardAction('@routing/LOAD_SCENE_FAILURE')<AppScene>(),
};